"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts"

const data = [
  { name: "Mon", pass: 42, fail: 2 },
  { name: "Tue", pass: 58, fail: 3 },
  { name: "Wed", pass: 75, fail: 1 },
  { name: "Thu", pass: 62, fail: 4 },
  { name: "Fri", pass: 68, fail: 2 },
]

export function QcStats() {
  return (
    <Card className="col-span-4">
      <CardHeader>
        <CardTitle>QC Performance</CardTitle>
      </CardHeader>
      <CardContent className="pl-2">
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="pass" name="Passed" fill="#16a34a" />
            <Bar dataKey="fail" name="Failed" fill="#dc2626" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  )
}
